import { render, staticRenderFns } from "./FeaturedImageEditor.vue?vue&type=template&id=045c58a9&"
import script from "./FeaturedImageEditor.vue?vue&type=script&lang=js&"
export * from "./FeaturedImageEditor.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedImageEditor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VCardText,VImg})
